export default __webpack_public_path__ + "static/fab-b3383dab2e66327aba8f1a511a6263c6.jpg";